<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="specimen-klinik">
      <div class="sticky-table-header">
        <vx-card style="overflow-x: auto;">
          <vs-row>
            <vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
              <vs-input ref="searchTxt" icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Pencarian berdasarkan tanggal order/no lab/nama pasien" v-model="searchText"  v-on:keyup.enter="search" />
              <vs-tooltip text="Edit" v-if="btnEdit === true">
                <vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="activePrompt=true;action='Update'"></vs-button>
              </vs-tooltip>
              <vs-tooltip text="Kirim Ke Worklist" v-if="btnEdit === true">
                <vs-button radius size="large" type="border" color="primary" icon="send" class="ml-3" @click="activedPrompt"></vs-button>
              </vs-tooltip>
              <vs-tooltip text="Hapus" v-if="btnDel === true">
                <vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3" @click="openConfirm"></vs-button>
              </vs-tooltip>
            </vs-col>
          </vs-row>
        </vx-card>
      </div>

      <vx-card title="Daftar Specimen Klinik" class="sticky-table-content1 mt-sticky">
        <vs-table max-items="10"
          :class="showFixedHeader?'sticky-header':''"
          :data="listData"
          @selected="handleSelected">
            <template slot="thead">
              <vs-th class="vs-lg-2">Tgl Order</vs-th>
              <vs-th class="vs-lg-4">Pasien</vs-th>
              <vs-th class="vs-lg-3">Data Lab</vs-th>
              <vs-th class="vs-lg-2">Status</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody :key="indextr" v-for="(tr, indextr) in data">
                <vs-tr :data="tr" :style="tr.id==idSelected?'background: rgba(var(--vs-primary),.1)!important;':(indextr%2==0?'background: transparent!important;':'')">
                    <vs-td class="vs-lg-2 text-center" style="padding-left: 7px !important; padding-right: 7px !important">
                        {{data[indextr].queue.createdAt | formatDate}}
                    </vs-td>
                    <vs-td class="vs-lg-3">
                        <b>{{data[indextr].queue.patient?data[indextr].queue.patient.name:''}}{{' ('+(data[indextr].queue.patient?data[indextr].queue.patient.patientNumber:'')+')'}}</b><br/>
                        <label style="font-size: 12px">{{data[indextr].queue.patient.dob | calcAge1}} {{(data[indextr].queue.patient?(' / '+data[indextr].queue.patient.gender.name):'')}}</label>
                    </vs-td>
                    <vs-td class="vs-lg-3 text-center">
                      <b>{{data[indextr].queue.patientType.name}} | {{data[indextr].queue.priority.name}}</b><br/>
                      <label style="font-size: 12px">{{data[indextr].queue.ward.name}}</label>
                    </vs-td>
                    <vs-td class="vs-lg-4 text-center">
                      <label style="font-size: 12px" :color="data[indextr].status.code==='SREJ'?'red':''">{{data[indextr].status.name}}</label>
                    </vs-td>
                </vs-tr>
              </tbody>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>
      </vx-card>

      <vs-prompt class="w40"
        style="overflow: auto:"
        title="Konfirmasi Penerimaan Specimen & Kirim ke Worklist"
        @accept="acceptAlert"
        accept-text="Kirim"
        cancel-text="Batal"
        color="#6488e4"
        :active.sync="activePromptWorklist">
        <vx-card>
           <vs-row>
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
               <vs-select
                 autocomplete
                 class="w-full"
                 name="specimenType"
                 placeholder="Pilih Tipe Specimen"
                 v-model="specimenType"
                 >
                 <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listSpecimenType" />
               </vs-select>
             </vs-col>
           </vs-row>
           <vs-row class="mt-4">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
               <ul class="center flex">
                 <li class="mr-8">
                   <vs-radio v-model="acceptance" vs-name="acceptance" vs-value="tolak">Ditolak</vs-radio>
                 </li>
                 <li class="ml-8">
                   <vs-radio v-model="acceptance" vs-name="acceptance" vs-value="terima">Diterima</vs-radio>
                 </li>
               </ul>
             </vs-col>
           </vs-row>
           <vs-row class="mt-4" v-if="acceptance==='tolak'">
             <vs-col class="w-full flex" vs-justify="center" vs-align="center">
               <vs-select
                  autocomplete
                  class="w-full"
                  name="reason"
                  placeholder="Pilih Alasan Spesimen Tidak Diterima"
                  v-model="reason"
                  >
                  <vs-select-item :key="index" :value="item.id" :text="item.reason" v-for="(item,index) in listReason" />
                </vs-select>
              </vs-col>
            </vs-row>
        </vx-card>
       </vs-prompt>
    </div>
</template>

<script>
import visit from "@/api/visit";
import test from "@/api/test";

export default {
  data() {
    return {
			idSelected: null,
			listData: [],
      listTest: [],
			loading: true,
			perPage: 20,
			page: 1,
      totalItem: 1,
      btnEdit: false,
      btnDel: false,
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
      activePromptWorklist:false,
      activePrompt:false,
      dataPatient: {},
      dataPatientModel: {},
      specimenType: '',
      reason: '',
      listSpecimenType: [],
      listReason: [],
      acceptance: 'terima',
      searchText: '',
      isUserScrolling: false,
      showFixedHeader: false,
      isMobile: false
    };
  },
  methods: {
    activedPrompt() {
      this.activePromptWorklist=true;
      this.getListSpecimentType();
      this.getListReason();
      this.specimenType= '';
      this.reason='';
    },
		async getListSpecimentType() {
			const frm = await test.getListSpecimentType();
			if (frm.data.status) {
				this.listSpecimenType= frm.data.data;
			}
		},
		async getListReason() {
			const frm = await test.getListSpecimentReject();
			if (frm.data.status) {
				this.listReason= frm.data.data;
			}
		},
    openConfirm() {
        this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: `Konfirmasi`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptDelete
        })
    },
    acceptDelete() {
      let config = {
        headers: {
          "content-type": "application/json"
        }
      };

      const x = { id : this.idSelected }
      test.deleteQueue(x, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di hapus",
							color: "success",
							position: "top-right"
						});

            var index = this.listData.map((o) => o.id).indexOf(this.idSelected);
            this.listData.splice(index, 1);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
    },
    acceptAlert() {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};

      const x = { id : this.idSelected }
      x.specimenType = { id : this.specimenType };

      if (this.acceptance==='terima') {
        visit.specimenAccept(x, config)
  				.then(res => {
  					if (res.data.status) {
  						this.$vs.notify({
  							title: "Info",
  							time: 3000,
  							text: "Spesimen Diterima dan Dikirim ke Worklist",
  							color: "success",
  							position: "top-right"
  						});

              var index = this.listData.map((o) => o.id).indexOf(this.idSelected);
              this.listData.splice(index, 1);
  					} else {
  						this.$vs.notify({
  							title: "Terjadi Kesalahan",
  							time: 3000,
  							text: res.data.message,
  							color: "danger",
  							position: "top-right"
  						});
  					}
  				})
  				.catch(error => {
  					if (error.response) {
  						this.$vs.notify({
  							title: "An Error Occured",
  							time: 3000,
  							text: error.response.data.message,
  							color: "danger",
  							position: "top-right"
  						});
  					}
  				});
      } else {
        x.rejectionReason = { id : this.reason }
        visit.specimenReject(x, config)
          .then(res => {
            if (res.data.status) {
              this.$vs.notify({
                title: "Info",
                time: 3000,
                text: "Data telah berhasil di submit",
                color: "success",
                position: "top-right"
              });
            } else {
              this.$vs.notify({
                title: "Terjadi Kesalahan",
                time: 3000,
                text: res.data.message,
                color: "danger",
                position: "top-right"
              });
            }
          })
          .catch(error => {
            if (error.response) {
              this.$vs.notify({
                title: "An Error Occured",
                time: 3000,
                text: error.response.data.message,
                color: "danger",
                position: "top-right"
              });
            }
          });
      }
      this.find(1);
    },
    onConfirm() {
      this.activePrompt = true;
      this.subm = true;

      if (this.dataPatientModel.ward!=='') {
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Simpan data, data order akan diupdate ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.saveData
        })
        this.saveData(this.dataPatientModel);
      }
    },
		async find(pg) {
			this.model["perPage"] = this.perPage;
      this.model["page"] = pg;
      this.model["lab_section_id"] = 1;
			const frm = await visit.specimenList(this.model);
			if (frm.data.status) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
			   this.listData = [];
      }
		},
    handleSelected(tr) {
      this.idSelected = tr.id;
      this.btnEdit = true;
      this.btnDel = true;
      this.getDetail(tr.id);
    },
    saveData(model) {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};
      model.wardName = model.ward;
      model.ward = null;
      model.labSection = {id : 1};
      model.id = this.idSelected;
			test.updateQueue(model, config)
				.then(res => {
          this.activePrompt=false;
					if (res.data.status) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: `Konfirmasi`,
                text: 'Data Order telah berhasil di update',
                acceptText: 'Buat Order Baru',
                cancelText: 'Lihat Daftar Antrian',
                accept: this.clear,
                cancel: this.toQueue
            })
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
        .finally();
		},
		async getDetail(id) {
			const frm = await visit.getDetailQueue(id);
			if (frm.data.status) {
				this.dataPatient= frm.data.data[0];
			}
		},
    handleScroll(ev) {
      if(!this.isMobile) {
          this.isUserScrolling = (window.scrollY > 0);
          if (this.isUserScrolling) {
              if (window.pageYOffset > 45) {
                  this.showFixedHeader = true;
              } else {
                  this.showFixedHeader = false;
              }
          } else {
              this.showFixedHeader = false;
          }
      }
    },
    setFocusOnInput(inputName) {
       /**
        * @see https://vuejs.org/v2/api/#vm-el
        * @see https://vuejs.org/v2/api/#vm-refs
        */
        // you could just call this.$refs[inputName].focusInput() but i'm not shure if it belongs to the public API
        let inputEl = this.$refs[inputName].$el.querySelector('input');
        console.log(inputEl.focus);
        inputEl.focus();
    },
    isMobileDevice() {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        console.log(navigator.userAgent);

        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    },
		async search() {
      this.page = 1;
			this.model["perPage"] = this.perPage;
      this.model["page"] = 1;
      this.model["lab_section_id"] = 1;
      this.model["keyword"] = this.searchText
			const frm = await visit.queueClinicList(this.model);
			if (frm.data.status) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
			   this.listData = [];
      }
		},
  },
  computed: {
  },
  mounted() {
      this.isMobile = this.isMobileDevice();
  },
  created() {
      document.addEventListener('scroll', this.handleScroll);
      this.$nextTick(() => this.setFocusOnInput('searchTxt'))

  },
  destroyed() {
      document.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss">
.w50 .vs-dialog {
    max-width:50%;
}

.w80 .vs-dialog {
    max-width:80%;
}
.vs-dialog {
    max-height: 90%;
    overflow-y: auto;
}
.vs-dialog-header {
    padding-right: 22px;
    padding-top: 10px;
}
.vs-table tbody tr:hover {
    border:none;
}
</style>
